import { BaseStore, getOrCreateStore } from '@Di'
import { action, observable } from 'mobx'

class SidebarStore extends BaseStore {
  @observable active = null

  @action
  open(key) {
    this.active = key
  }

  @action
  close() {
    this.active = null
  }

  hasOpen() {
    return this.active !== null
  }

  isOpen(key) {
    return this.active === key
  }
}

export default getOrCreateStore('SidebarStore', SidebarStore)
